var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageDefaultContact({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0548096,
    width: 40,
    height: 40,
    rx: 20,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4324_36191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0.0548096C8.96 0.0548096 0 9.01481 0 20.0548C0 31.0948 8.96 40.0548 20 40.0548C31.04 40.0548 40 31.0948 40 20.0548C40 9.01481 31.04 0.0548096 20 0.0548096ZM20 6.05481C23.32 6.05481 26 8.73481 26 12.0548C26 15.3748 23.32 18.0548 20 18.0548C16.68 18.0548 14 15.3748 14 12.0548C14 8.73481 16.68 6.05481 20 6.05481ZM20 34.4548C15 34.4548 10.58 31.8948 8 28.0148C8.06 24.0348 16 21.8548 20 21.8548C23.98 21.8548 31.94 24.0348 32 28.0148C29.42 31.8948 25 34.4548 20 34.4548Z",
    fill: "#D5D7DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4324_36191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.0548096)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDefaultContact);
export default __webpack_public_path__ + "static/media/imageDefaultContact.4fdd366b9e9a9bc0c8e58122f44b347f.svg";
export { ForwardRef as ReactComponent };